import React from 'react'
import PropTypes from 'prop-types'
import {
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ComposedChart,
  Area,
  Label,
} from 'recharts'
import { CSVLink } from 'react-csv'
import { variables } from '@resurs/midas'
import { getText } from '../../../../internal/TextLabels'

const SimpleBarChart = props => {
  return (
    <div>
      <ResponsiveContainer height={500}>
        <ComposedChart
          width={600}
          height={300}
          data={props.data}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          <XAxis dataKey="name">
            <Label
              value={getText('statistics.barchart.xAxisLabel')}
              offset={0}
              position="insideBottomRight"
            />
          </XAxis>
          <YAxis>
            <Label
              position="insideTopLeft"
              dx={60}
              dy={-30}
              style={{ textAnchor: 'middle' }}
            >
              {getText('statistics.barchart.yAxisLabel')}
            </Label>
          </YAxis>
          <Tooltip />
          <Legend verticalAlign="top" height={60} />
          <CartesianGrid stroke="#f5f5f5" />
          <Area
            type="monotone"
            dataKey="average"
            fill={variables.controlColorWarning}
            stroke={variables.controlColorWarning}
            name={getText('statistics.average')}
          />
          <Bar
            dataKey="amount"
            fill={variables.coreColor}
            fillOpacity={0.6}
            name={props.label}
          />
        </ComposedChart>
      </ResponsiveContainer>
      <div style={{ textAlign: 'right', fontSize: '1rem' }}>
        <CSVLink data={props.data} filename="barchart.csv" target="_blank">
          {props.dllink}
        </CSVLink>
      </div>
    </div>
  )
}

SimpleBarChart.propTypes = {
  data: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired,
  dllink: PropTypes.string,
}
SimpleBarChart.defaultProps = {
  dllink: 'Get CSV-file',
}

export default SimpleBarChart
